import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/AccountCircle'

import CompanyLogo from '../../../shared/components/CompanyLogo'

import * as React from 'react';
import { NavLink } from 'react-router-dom';
import {login, logout} from '../../auth/identityAuth';
import { Menu, MenuItem } from '@material-ui/core';

const styles: StyleRulesCallback = (theme: any) => ({
  appBar: {
    position: 'absolute',
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  navButtonsHide: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
});
const ProfileLink = (props: any) => <NavLink to="/profile/" {...props} />
interface IState {
  anchorEl: undefined,
}
class NavTop extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      anchorEl: undefined,
    }
  }

  public handleClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  public handleClose = () => {
    this.setState({ anchorEl: undefined });
  };
  public render() {
    const { classes } = this.props;
    return (
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={this.props.menuToggleHandler}
            className={classes.navIconHide}
          >
            <MenuIcon />
          </IconButton>
          <CompanyLogo />
          {!this.props.disableNavigation &&
            <Button className={classes.navButtonsHide} href={process.env.REACT_APP_PUBLIC_WEBSITE_URL} target="_blank" color="inherit">NxtPort.com</Button>
          }
          {!this.props.disableNavigation &&
            <Button className={classes.navButtonsHide} href="https://documentation.nxtport.com/data-services/data-services-overview" target="_blank" color="inherit">Data Services</Button>
          }
          {!this.props.disableNavigation &&
            <Button className={classes.navButtonsHide} href="https://www.certifiedpickup.eu/en" target="_blank" color="inherit">Certified Pick up</Button>
          }
          {this.props.user &&
            <div>
              <Button
                color="inherit"
                aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}
              >
                <PersonIcon className="margin-right-8" /> {this.props.user.firstName} {this.props.user.lastName}
              </Button>
              {!this.props.disableNavigation &&
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleClose} component={ProfileLink}>Profile</MenuItem>
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </Menu>
              }
            </div>
          }
          {!this.props.user &&
            <Button color="inherit" onClick={login}>Login</Button>
          }
          {!this.props.user &&
            <Button color="inherit" href={process.env.REACT_APP_REGISTER_URL}>Register</Button>
          }
        </Toolbar>
      </AppBar>
    )
  }
}
export default withStyles(styles)(NavTop);


// WEBPACK FOOTER //
// ./src/modules/core/components/nav-top/NavTop.tsx